const mergeProfileUpdate = (profile, updateData, uid) => {
  const merged = { ...(profile || {}), ...(updateData || {}), uid: uid || profile?.uid };
  const usertype = merged.usertype || merged.userType || 'customer';
  return { ...merged, usertype, userType: usertype };
};

module.exports = { mergeProfileUpdate };
